module.exports = __webpack_public_path__ + "static/media/fm.794d7a03.svg";